<template>
	<p class="description__text mv-s">
		Een {{ productName.toLowerCase() }} met {{ pageCount }} pagina's heeft {{ pageCount / 2 }} vellen.
		Kiest u voor dubbelzijdige bedrukking voor het binnenwerk dan zijn er dus {{ pageCount }} zijdes die u kunt opmaken.
		Kiest u voor enkelzijdige bedrukking dan zijn er maar {{ pageCount / 2 }} drukbare zijdes.
		Bij enkelzijdige bedrukking zijn er om en om wel en geen drukbare zijde.
		Wanneer u kiest voor een enkelzijdige bedrukking levert u enkel de bedrukte pagina’s aan in het PDF.
		{{ textMinMaxIncrement }}
	</p>
</template>

<script>
export default {
	name: "Description",
	data () {
		return {};
	},
	computed: {
		textMinMaxIncrement () {
			return `Dit product heeft een minimum van ${this.selectedFormat.minPageCount} en een maximum van ${this.selectedFormat.maxPageCount} pagina's met een meervoud van ${this.selectedFormat.pageIncrement}.`;
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		pageCount () {
			return this.$store.getters.getPageCount;
		},
		productName () {
			return this.$store.getters.getSelectedProduct.name || "Product";
		}
	}
};
</script>

<style lang="scss">
.description {
	margin-bottom: 20px;
	padding: 12px 16px;
	color: var(--cfg-primary-dark);
	background: var(--cfg-primary-tint-alt);

	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;

	border: 1px solid var(--cfg-primary-border);
	border-radius: 8px;
}

.description--vertical {
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
}

.description__link-container {
	width: 100%;
	columns: 200px;
}

.description__link,
.description__link.link {
	font-family: Inter;
	font-size: 1.3rem;
	font-weight: 400;
	line-height: 160%;
}

.description__icon {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
	fill: var(--cfg-primary-dark);
	color: var(--cfg-primary-dark);
}

.description__text {
	color: #475467;
	font-family: Inter;
	font-size: 16px;
	font-weight: 400;
	line-height: 160%;
}

.description__button {
	display: block;
	padding: 8px 16px;
	border-radius: 8px;
	background: none;

	font-size: 16px;
	font-weight: 600;
	line-height: 140%;
	text-align: center;
	vertical-align: middle;
	color: var(--cfg-primary-dark);

	cursor: pointer;
	border: 2px solid var(--cfg-primary-border);
	&:hover {
		opacity: .8;
	}
}

@media screen and (max-width: 600px) {
	.description {
		flex-direction: column;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/element/description.vue